import "./NewButton.css"

const NewButton = (props) => {
    
return (

    <div class="btn-2" >
   
    <a href="/blogs/new"><span>{props.name}</span></a>
  </div>
      
)

}



export default NewButton;